
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparSquare as ObiBuoySparSquareElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-square.js';
 
 
 

 
 export const ObiBuoySparSquare = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-square',
   elementClass: ObiBuoySparSquareElement,
   events: {
     
   }
  });
 
 